import React from 'react';
import styled from 'styled-components';

import { PulseLoaderNoWrapper } from 'src/styledComponents/Loader/PulseLoader';

const Wrapper = styled.div`
  z-index: 50;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

export function FullScreenPulse() {
  return (
    <Wrapper>
      <PulseLoaderNoWrapper />
    </Wrapper>
  );
}
